import React from "react";
import { cn } from "@/lib/utils";
import { initials } from "@/lib/format";

const sizes = {
  sm: "h-8 w-8 text-[11px]",
  md: "h-10 w-10 text-xs",
  lg: "h-16 w-16 text-lg",
  xl: "h-24 w-24 text-2xl",
};

export const UserAvatar = ({ name = "", src = "", size = "md", className, ring = false }) => (
  <span
    key={`${name}-${src}`}
    className={cn(
      "relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold uppercase tracking-wide select-none",
      src ? "bg-muted" : "bg-primary-soft text-primary",
      ring && "ring-2 ring-primary/25 ring-offset-2 ring-offset-background",
      sizes[size],
      className
    )}
    aria-label={name}
  >
    {src ? (
      <img src={src} alt={name} className="h-full w-full object-cover" />
    ) : (
      <span>{initials(name)}</span>
    )}
  </span>
);
